module.exports = __webpack_public_path__ + "img/18.9fe23549.png";